import React from "react";
import TermEmotii from "../../images/emotii-term.png";
import useFooter from "../../hooks/useFooter";
import BrandingFooter from "../Footer/BrandingFooter";
import { useDispatch } from "react-redux";
import {
  incrementCurrentSlide,
  incrementPeekSlide,
} from "../../store/slices/slides";

function TermsSlide({ isVisible }) {
  const dispatch = useDispatch();
  useFooter(isVisible, <BrandingFooter />);

  return (
    <div className="h-full bg-emotii-terms">
      <div className="block-emotti">
        {" "}
        <div className="block-welcome">
          <img src={TermEmotii} alt="" className="emotii-ttl" />

          <div className="text-right">
            <h1 className="">Terms of Use </h1>
          </div>

          <div className="flex w-full">
            <p className="text-lg leading-[22px] ">
              Please note... this screening tool is not intended to diagnose any
              medical disease, disorder or dysfunction, and should not be used
              as a substitute for medical exams, advice, or intervention by
              qualified healthcare or behavioral health providers.
              <br />
              <br />
              The developers and providers of this screening tool disclaim all
              liability, loss, or risk incurred, directly or indirectly, as a
              consequence of use or dissemination of this material.
            </p>
          </div>

          <div className="btn-box-introduction">
            <a
              href="#"
              className="btn btn-white"
              onClick={() => {
                dispatch(incrementCurrentSlide());
                dispatch(incrementPeekSlide());
              }}
            >
              I understand and consent
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TermsSlide;
